import React, { useEffect, useMemo, useState } from 'react';
import '../css/Project.css';
import '../css/Collab.css';
import { Shape1, ShapeRectangle, Shape3 } from '../components/Shapes';

const WEEKDAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

function formatTime(date) {
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' });
}

const Dashboard = () => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const dayOfWeek = WEEKDAYS[now.getDay()];

  const tasksByDay = useMemo(
    () => ({
      Monday: ['Prep dough & fillings', 'Confirm wholesale orders', 'Post weekly IG story'],
      Tuesday: ['Bake test batch', 'Supplier check-in', 'Update menu list'],
      Wednesday: ['Production bake', 'Pack & label', 'Delivery / pickup window'],
      Thursday: ['R&D new flavour', 'Clean + restock', 'Reply to customer messages'],
      Friday: ['Production bake', 'Weekend prep', 'Confirm Saturday pickups'],
      Saturday: ['Bake early batch', 'Market / pickups', 'End-of-day inventory'],
      Sunday: ['Restock pantry list', 'Plan next week', 'Light admin + finances'],
    }),
    []
  );

  const tasksOfToday = tasksByDay[dayOfWeek] ?? [];

  return (
    <div className="homepage">
      <header className="intro">
        <div className="shapes-container-inside blur-desktop blur-mobile">
          <ShapeRectangle className="shape shape-5" />
          <Shape3 className="shape shape-6" />
        </div>

        <div className="hero generic-hero">
          <h1>Dashboard</h1>
        </div>
      </header>

      <div className="shapes-container-outside">
        <Shape1 className="shape shape-1" />
        <ShapeRectangle className="shape shape-2" />
        <Shape3 className="shape shape-3" />
        <Shape1 className="shape shape-4" />
      </div>

      <section className="section-intro">
        <div className="challenges-content">
          <p>
            <strong>{dayOfWeek}</strong>
            <br />
            {formatTime(now)}
          </p>
        </div>
      </section>

      <section className="case-studies">
        <div className="case-studies-grid">
          <div className="section-header">
            <h2>Tasks</h2>
          </div>

          <div className="cases">
            <div className="collab-model move-right">
              <h2>Tasks of the week</h2>
              <ul>
                {WEEKDAYS.map((day) => (
                  <li key={day}>
                    <strong>{day}:</strong> {(tasksByDay[day] ?? []).join(' • ') || '—'}
                  </li>
                ))}
              </ul>
            </div>

            <div className="collab-model move-left">
              <h2>Tasks of the day</h2>
              <ul>
                {tasksOfToday.length ? (
                  tasksOfToday.map((task) => <li key={task}>{task}</li>)
                ) : (
                  <li>No tasks set for today yet.</li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Dashboard;

